import { PHARMACY_COPY } from '../pharmacyCopy';

const stockCopy = PHARMACY_COPY.STOCK_TABLE;

/** Jours restants avant péremption (négatif = périmé). */
export function lotExpiryDays(expiry) {
  if (!expiry) return null;
  const days = Math.ceil((new Date(expiry) - new Date()) / 86400000);
  return Number.isFinite(days) ? days : null;
}

export function lotExpiryTone(expiry) {
  const days = lotExpiryDays(expiry);
  if (days == null) return '';
  if (days < 0) return 'cp-lot-pill--danger';
  if (days <= 60) return 'cp-lot-pill--warn';
  return 'cp-lot-pill--ok';
}

export function lotExpiryTag(expiry) {
  const days = lotExpiryDays(expiry);
  if (days == null) return '—';
  if (days < 0) return stockCopy.EXPIRY_EXPIRED;
  if (days <= 60) return stockCopy.EXPIRY_SOON;
  return stockCopy.EXPIRY_OK;
}

export function lotExpiryHint(expiry, copy) {
  const days = lotExpiryDays(expiry);
  if (days == null) return copy?.LOT_NO_EXPIRY || 'Sans date';
  if (days < 0) {
    return (copy?.LOT_EXPIRED_DAYS || 'Périmé depuis {n} j').replace('{n}', String(Math.abs(days)));
  }
  if (days === 0) return copy?.LOT_EXPIRES_TODAY || 'Expire aujourd’hui';
  if (days <= 60) {
    return (copy?.LOT_EXPIRES_IN || 'Expire dans {n} j').replace('{n}', String(days));
  }
  return (copy?.LOT_EXPIRES_IN || 'Expire dans {n} j').replace('{n}', String(days));
}
